import { iconPropsBase } from './_base.js';

/** @type {React.ComponentType} */
export default function LightbulbIcon() {
  return (
    <svg
      {...iconPropsBase}
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        d="M13.3878 22.5417H10.6378"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3045 20.7083H9.72113"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0128 1.45825V4.20825"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.23401 4.68066L6.17918 6.62491"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7907 4.68066L17.8465 6.62491"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.47113 12.4583H4.22113"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5546 12.4583H19.8046"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5128 12.4582C17.5139 11.5122 17.2709 10.582 16.8074 9.75737C16.3439 8.93274 15.6756 8.24158 14.867 7.75069C14.0584 7.25979 13.1368 6.98575 12.1913 6.95505C11.2459 6.92434 10.3085 7.13801 9.46971 7.57541C8.63095 8.0128 7.91918 8.65914 7.40317 9.45197C6.88716 10.2448 6.58435 11.1573 6.52402 12.1013C6.46368 13.0454 6.64785 13.989 7.05873 14.8411C7.46961 15.6932 8.09331 16.4248 8.86957 16.9655C8.99095 17.0499 9.09011 17.1624 9.15859 17.2935C9.22706 17.4245 9.26282 17.5702 9.26282 17.718V18.4165C9.26282 18.5381 9.3111 18.6547 9.39706 18.7406C9.48301 18.8266 9.59959 18.8749 9.72115 18.8749H14.3045C14.3647 18.8749 14.4243 18.863 14.4799 18.84C14.5355 18.817 14.586 18.7832 14.6286 18.7406C14.6711 18.6981 14.7049 18.6475 14.7279 18.5919C14.751 18.5363 14.7628 18.4767 14.7628 18.4165V17.7171C14.7628 17.5693 14.7986 17.4236 14.867 17.2926C14.9355 17.1615 15.0347 17.049 15.1561 16.9645C15.8837 16.4597 16.4782 15.786 16.8886 15.0012C17.2991 14.2164 17.5132 13.3439 17.5128 12.4582Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
